<template>
    <section>
        <div class="resources">
            <div class="resources-top">
                <div class="title">
                    <div class="names">
                        <div style="height:28px;">
                            <img style="height:28px;width:28px;" src="@/assets/images/courierClass/z3.png" alt="">
                        </div>
                        <div class="titles">{{ $t('resources.Resources.874735-0') }}</div>
                        </div>
                    <div class="search">
                        <el-input
                            @keyup.enter.native="search"
                            clearable @clear="search"
                            :placeholder="$t('resources.Resources.874735-1')"
                            v-model="params.keywords">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                        </el-input>
                    </div>
                </div>
                <div class="btn" @click="addresourcesForm()">
                    <img src="@/assets/images/courierClass/z4.png" alt="">
                    <span>{{ $t('resources.Resources.874735-2') }}</span>
                </div>
            </div>
            <div class="layout_table">
                <MyTable
                    :emptyOptions='{ showBtn:false, btnText:"", handleClick: ()=>{}, text: noDataStr, }'
                    :data="tableData"
                    :isShowOrderNum="false"
                    :isShowPagination="false"
                    :emptyText="$t('resources.Resources.874735-4')"
                    :isHaveSerch="true"
                    >
                    <!-- 表格体 -->
                    <template v-slot:table>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-5')" 
                            align="center" fixed="left"
                            show-overflow-tooltip  width="60px"
                            prop="image">
                            <template slot-scope="scope">
                                {{scope.$index+1}}
                            </template>
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-6')" 
                            align="center"  width="300px"
                            show-overflow-tooltip 
                            prop="title">
                            <template slot-scope="scope">
                                <span @click="goPubilcDetail(scope.row)" style="color:#009A3E;cursor:pointer;">{{scope.row.title}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-7')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="isVideo">
                            <template slot-scope="scope">
                                <template v-if="scope.row.isVideo==0">{{ $t('resources.Resources.874735-8') }}</template>
                                <template v-if="scope.row.isVideo==1">{{ $t('resources.Resources.874735-9') }}</template>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-10')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="auditStatus">
                            <template slot-scope="scope">
                                <span style="color:#5B89EA;" v-if="scope.row.auditStatus==0">{{ $t('resources.Resources.874735-11') }}</span>
                                <span v-if="scope.row.auditStatus==1">{{ $t('resources.Resources.874735-12') }}</span>
                                <span style="color:#FD8282;" v-if="scope.row.auditStatus==2">{{ $t('resources.Resources.874735-13') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-14')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="onShelves">
                            <template slot-scope="scope">
                                <template v-if="scope.row.onShelves==0">{{ $t('resources.Resources.874735-15') }}</template>
                                <template v-if="scope.row.onShelves==1">{{ $t('resources.Resources.874735-16') }}</template>
                            </template>
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-17')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="author">
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-18')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="browseCount">
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-19')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="praiseCount">
                        </el-table-column>
                        <el-table-column 
                            :label="$t('resources.Resources.874735-20')" 
                            align="center" 
                            show-overflow-tooltip 
                            prop="collectCount">
                        </el-table-column>
                        <el-table-column :label="$t('resources.Resources.874735-21')" align="center" width="150px" fixed="right">
                            <template slot-scope="scope">
                                <template v-if="scope.row.onShelves==true">
                                    <el-button class="other" type="text" @click="dataOnShelves(scope.row.id,0)">{{ $t('resources.Resources.874735-15') }}</el-button>
                                </template>
                                <template v-else>
                                    <el-button class="other" type="text" v-if="scope.row.auditStatus==1" @click="dataOnShelves(scope.row.id,1)">{{ $t('resources.Resources.874735-16') }}</el-button>
                                    <el-button class="other" type="text" v-if="scope.row.auditStatus==0||scope.row.auditStatus==1" @click="modifyFormresourcesForm(scope.row)" >{{ $t('resources.Resources.874735-22') }}</el-button>
                                    <el-button class="del" type="text" @click="delresources(scope.row.id)">{{ $t('resources.Resources.874735-23') }}</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </MyTable>
            </div>
            <div class="page">
                <pagination
                    :pageSize="params.rows"
                    :pageSizes="pageSizes"
                    :currentPage="params.page"
                    :total="total"
                    @current-change="changePage"
                    @size-change="sizeChange"
                    style="margin-top:12px;"
                    >
                </pagination>
            </div>
        </div>
        <!-- <modifyForm ref="modifyForm"></modifyForm> -->
        <MyDialog :isShow="isShow" @close="closeDialogFn" :title="$t('resources.Resources.874735-2')" class="myDialog" width="700px" top="10vh">
            <template name="body">
                <div class="dialog-box">
                    <!-- 1-名师，2-名校，3-专递课堂 -->
                    <addResource @backFn="backFn" @submiteFn="submiteFn" :origin="3"/>
                </div>
            </template>
        </MyDialog>
    </section>
</template>
<script>
import MyDialog from "components/MyDialog/MyDialog.vue"
import MyTable from "components/MyTable/MyTable.vue";
import pagination from "components/pagination/index.vue";
import * as api_courier from 'service/api/methods/api_courier'
import modifyForm from './components/modifyForm'
import addResource from 'components/addResource/addResource'
import i18n from '@/locale/index';

export default { 
    components:{
        pagination,
        modifyForm,
        MyTable,
        addResource,
        MyDialog
    }, 
    data(){
        return{
            params:{
                keyworks:'',
                page:1,
                rows:15
            },
            total:0,
            pageSizes:[10, 15, 20, 25,30],
            tableData:[],
            isShow:false,
        }
    },
    computed: {
        noDataStr() {
            return i18n.t('resources.Resources.874735-3')
        }
    },
    
    created(){
        this.getData();
    },
    methods:{
        getData(){
            this.getlistTheme(this.params);
        },
        search(){
            this.params.page = 1;
            this.getData();
        },
        changePage(val){
            this.params.page = val;
            this.getData();
        },
        sizeChange(val){
            this.params.page = 1;
            this.params.rows = val;
            this.getData();
        },
        getlistTheme(params){//资源管理列表
            api_courier.getlistTheme(params).then((res)=>{
                if(this.$utils.isArrayEmpty(res.data.records) && (res.data.total > 0)){
                    this.params.page=1;
                    this.getData();
                }
                this.tableData=res.data.records;
                this.total=res.data.total;
            }).catch(()=>{
                this.tableData=[];
            })
        },
        modifyFormresourcesForm(row){
            this.$refs.modifyForm.init(true,row);
        },
        delresources(id){
            this.$msg.alert(this.$t('resources.Resources.874735-24'),this.$t('resources.Resources.874735-25'))
            .then(()=>{
                this.resourceUpdate({id:id,isDelete:1});
            })
            .catch(()=>{
            });
        },
        dataOnShelves(id,type){//上下架
            let str = type == 0 ? this.$t('resources.Resources.874735-15') : this.$t('resources.Resources.874735-16');
            this.$msg.alert(this.$t('resources.Resources.874735-26')+str+this.$t('resources.Resources.874735-27'),this.$t('resources.Resources.874735-25'))
            .then(()=>{
                this.resourceUpdate({id:id,onShelves:type});
            })
        },
        resourceUpdate(p){//修改、上下架、删除
            api_courier.resourceUpdate(p).then((res)=>{
                this.$msg.success(res.message, this.$t('resources.Resources.874735-28'))
                this.getData();
            })
        },
        addresourcesForm(){
            this.isShow = true;
        },
        closeDialogFn () {
           this.isShow = false;
        },
        backFn () {
            this.closeDialogFn()
        },
        submiteFn () {
            this.closeDialogFn();
            this.getData();
        },
        goPubilcDetail(item){
            this.$router.push({path:'/courierclass/courierdetail',query:{id:item.id,browseType:1}});
        }
    }
    
}
</script>
<style lang="less" scoped>
.resources{
    /deep/.el-input__suffix-inner {
        display: flex;
        flex-direction:row-reverse;
    }
    .search /deep/.el-input--suffix .el-input__inner{
        border-radius: 21px;
    }
    i{
            cursor: pointer;
        }
}
.myDialog{
    /deep/ .el-dialog__body{
        padding-bottom: 0 !important;
    }
    .dialog-box{
        height: 650px;
        overflow-y: hidden;
        // padding: 32px 30px 30px;
    }
}
section{
    width:100%;
    position: absolute;
    min-height: calc(100% - 66px);
    background: #fff;
    .resources-top{
        width:100%;
        background: #fff;
        padding:27px 0 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .names{
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .titles{
                margin:0 26px 0 5px;
                font-size: 26px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                color: #333333;
            }
            .search{
                width:380px;
                margin-left:20px;
            }
        }
        .btn{
            margin-left:10px;
            width:130px;
            height: 40px;
            display: flex;
            font-size: 14px;
            align-items: center;
            background: #009A3E;
            border-radius: 20px;
            color:#fff;
            cursor: pointer;
            img{
                width:15px;
                height: 15px;
                margin-left:13px;
                margin-right:5px;
            }
        }
    }
    .resources{
        width:1200px;
        margin:0 auto;
        .resources-ul{
            li{
                padding:20px 0 20px 0;
                border-bottom: 1px solid #cccccc;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                font-size: 13px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #666666;
                .live-left{
                }
                .live-right{
                    cursor: pointer;
                }
                .p1{
                    font-weight: 700;
                    color: #333333;
                    margin-bottom:10px;
                }
                .p2{
                    margin-bottom:7px;
                }
            }
        }
        .nodata{
            min-height: 600px;
            line-height: 600px;
            text-align: center;
            color:#999;
        }
        .page{
            padding: 20px 0 50px 0;
            text-align: center;
        }
    }
}
</style>